export type XpoApplyFilterStrategy = 'global' | 'container' | 'auto';

export const DEFAULT_FILER_STRATEGY: XpoApplyFilterStrategy = 'auto';
